import { render, staticRenderFns } from "./CustomFieldsList.vue?vue&type=template&id=0ff50d4a&scoped=true&"
import script from "./CustomFieldsList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsList.vue?vue&type=style&index=0&id=0ff50d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff50d4a",
  null
  
)

export default component.exports